import { render, staticRenderFns } from "./BusinessesPage.vue?vue&type=template&id=4f963271&"
import script from "./BusinessesPage.vue?vue&type=script&lang=js&"
export * from "./BusinessesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports